// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatGptTextarea_wrapper__SQW+7","input":"ChatGptTextarea_input__yL2Fw"};